import "./index.css";
import { Link, useParams, useNavigate } from "react-router-dom";
import { socailSignUp } from "../../../redux/socialSignup/socialSignUp";
import { storeUser } from "../../../redux/users/usersSlice";
import { toastify } from "../../../helpers/toast/toastify";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import Binance from "../../../assets/images/onboardingImages/binance.svg";
import Bybit from "../../../assets/images/onboardingImages/bybit.svg";
import CheckIcon from "../../../assets/images/vipCheckMark.svg";
import Discord from "../../../assets/images/onboardingImages/discord.svg";
import SignupCM from "./SignupCM/SignupCM";
import Telegram from "../../../assets/images/onboardingImages/telegram.svg";
import useApi from "../../../helpers/apiHelper/requestHelper";
import {
  redirectToBinanceOAuth,
  redirectToBybitOAuth,
} from "../../../helpers/exchangeOAuth";
import BubbleSvgButton from "../../sharedPages/CommonComponents/BubbleSvgButton/BubbleSvgButton";
import { globalCommunity } from "../../../store/globalstore";
import { useAtom } from "jotai";
import StarImg from "../../../assets/images/onboardingImages/Star.svg";
import ProfileIcon from "../../../assets/images/Profile.svg";
import FadeStarImg from "../../../assets/images/onboardingImages/fadeStar.svg";
import UserIcon from "../../../assets/images/onboardingImages/ReviewUser.svg";
import StarIcon from "../../../assets/images/onboardingImages/ReviewStar.png";
import TrophyIcon from "../../../assets/images/trophy.svg";
import DollarIcon from "../../../assets/images/onboardingImages/ReviewDollar.png";
import { simplifyTradingVolume } from "../../../helpers/helper";

const ENV = window.location.hostname.split(".")[0] === "my" ? "prod" : "dev";

const OnboardingCM = () => {
  const [communityFromStore, setCommunityInStore] = useAtom(globalCommunity);
  const [isSignupWithEmail, setIsSignupWithEmail] = useState(localStorage.getItem("fromRoute")==="community"?true:false);
  const [reviewRes, setReviewRes] = useState();
  const { communityName } = useParams();
  const navigate = useNavigate();

  const api = useApi();
  const dispatch = useDispatch();

  const binanceButtonClick = () => {
    if (ENV !== "prod") {
      toastify("Binance Login Not Available on Dev", "success");
      return;
    }

    redirectToBinanceOAuth({ allowSocialLogin: true });
  };

  const byBitButtonClick = async () => {
    if (ENV !== "prod") {
      toastify("Bybit Login Not Available on Dev", "success");
      return;
    }

    redirectToBybitOAuth({ allowSocialLogin: true });
  };

  const getCommunity = async () => {
    try {
      const response = await api("post", "community/getCommunityByName", {
        name: communityName,
      });

      if (response?.status) setCommunityInStore(response.data?.found);
      else {
        toastify("Community not found!");
        navigate("/login");
      }
    } catch (error) {
      console.error("🚀 -> getCommunity -> error:", error);
    } finally {
    }
  };
 
  const handleJoining = async () => {
    if (!communityFromStore) return toastify("Community not found!");
    
    localStorage.setItem("fromRoute", "community"); // store whatever you want
    setIsSignupWithEmail(true);
  };

  const logOut = () => {
    dispatch(storeUser({ token: null, user: null }));
    dispatch(socailSignUp(null));
    localStorage.clear();
  };

  const loginWithDiscord = async () => {
    const stateData = {
      community: communityFromStore,
    };

    const encodedState = btoa(JSON.stringify(stateData));

    const discordOAuthURL = `${process.env.REACT_APP_DISCORD_OAUTH_URL}&state=${encodedState}`;

    window.location.href = discordOAuthURL;
  };

  const telegramRedirectUrl = () => {
    dispatch(
      socailSignUp({
        community: communityFromStore,
      })
    );

    const telegramOAuthURL = process.env.REACT_APP_TELEGRAM_OAUTH_URL;
    window.location.href = telegramOAuthURL;
  };

  useEffect(() => {
    getCommunity();
    // logOut();
  }, []);

  const getPublicCommunityReviews = async () => {
    try {
      const blockChainRes = await api(
        "post",
        "blocakChain/getCommunityDataFromSolana",
        {
          communityId: communityFromStore?._id,
        }
      );

      const isEmptyBlockChainData = !blockChainRes?.status;

      if (isEmptyBlockChainData) {
        const response = await api(
          "post",
          "communityReview/getPublicCommunityReviews",
          {
            communityId: communityFromStore?._id,
          }
        );
        
        if (response?.status) {
          const dbData = {
            average_rating: response.data?.averageRating || 0,
            total_reviews: response.data?.totalReviews || 0,
            win_rate: response.data?.WinRate || 0,
            subscribers: response.data?.totalMembers || 0,
            roi: response.data?.ROI || 0,
          };
          setReviewRes(dbData);
        }
      } else {
        // use blockchain data but format the keys to match expected ones
        const formattedBlockChainData = {
          average_rating: blockChainRes.data.averageRating,
          total_reviews: blockChainRes.data.totalReviews,
          win_rate: blockChainRes.data.WinRate,
          subscribers: blockChainRes.data.totalMembers,
          roi: blockChainRes.data.ROI,
        };
        setReviewRes(formattedBlockChainData);
      }
    } catch (error) {
      console.error("🚀 -> getPublicCommunityReviews -> error:", error);
    }
  };

  useEffect(() => {
    if (communityFromStore?.allowPublicReviews) {
      getPublicCommunityReviews();
    }
  }, [communityFromStore]);
  
  return (
    <>
      {isSignupWithEmail ? (
        <SignupCM />
      ) : (
        
        <div className="onboardinLayout cmSide">
          <div className="onboardingSignUp">
            <div className="onboardingCard PaddingZero">
              <div className="onboardingCardTopBox">
                {communityFromStore?.logo ? (
                  <img 
                  src={communityFromStore.logo} 
                    alt={`${communityFromStore?.disPlayName} logo`}
                    className="communityLogo"
                  />
                ):(
                  
                  <img src={ProfileIcon} alt="community logo" className="communityLogo" />
                  
                )}
                <p className="businessName">
                  {communityFromStore?.disPlayName?.toUpperCase()}&#8192;
                </p>
              </div>
              <div className="onboardingCardContentBox cmSide poiuCommunity">
                <div className="headingBox">
                  <h2 className="title">Join our copy trades now</h2>
                  <p className="subText">Get started in just 3 minutes!</p>
                </div>

                {communityFromStore?.allowPublicReviews && (
                  <div className="reviewDesingBox">
                    <div className="leftBox">
                      <div className="lbItem">
                        <div className="headingBox">
                          <img src={UserIcon} alt="user" />
                          <p className="heading">Members:</p>
                        </div>
                        <div className="numberBox">
                          <p className="number">{reviewRes?.subscribers}</p>
                        </div>
                      </div>
                      <div className="lbItem">
                        <div className="headingBox">
                          <img src={TrophyIcon} alt="winrate" />
                          <p className="heading">Winrate:</p>
                        </div>
                        <div className="numberBox">
                          <p className="number">{Number(reviewRes?.win_rate).toFixed(2)}%</p>
                        </div>
                      </div>
                    </div>
                    <div className="rightBox">
                      <div className="lbItem">
                        <div className="headingBox">
                          <img src={DollarIcon} alt="$" />
                          <p className="heading">ROI (YTD):</p>
                        </div>
                        <div className="numberBox">
                          <p className="number">{simplifyTradingVolume(Number(reviewRes?.roi).toFixed(2))}%</p>
                        </div>
                      </div>
                      <div className="d-flex flex-column justify-content-end">
                        <div className="lbItem">
                          <div className="headingBox">
                            <img src={StarIcon} alt="star" />
                            <p className="heading">Rating:</p>
                          </div>
                          <div className="numberBox">
                            <p className="number">
                              {reviewRes?.average_rating
                                ? `${Number(reviewRes.average_rating).toFixed(2)} / 5`
                                : "No ratings yet"}
                            </p>
                          </div>
                        </div>
                        
                        <div className="ms-4 -mt-1" style={{marginTop: "-10px"}}>
                          <p className="desc m-0 ms-1"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              navigate(
                                `/community/reviews/${communityFromStore?._id}`,
                                { replace: true }
                              );
                            }}>
                            {reviewRes?.total_reviews && reviewRes.total_reviews > 0
                              ? `Based on ${reviewRes.total_reviews} `
                              : "No reviews yet "}
                            <a>Reviews &#62;</a>
                          </p>
                        </div>
                      </div>
                      {/* <StarRating averageRating={reviewRes?.average_rating || 0}/> */}
                    </div>
                  </div>
                )}

                  <p className="fs-12 mx-4 text-center mb-2">100% Automated. Self-custodial. Cancel Anytime.</p>
                {/* <div className="checkListBox"> */}
                  {/* <p className="listItem">
                    <img src={CheckIcon} alt="check icon" />
                    100% automated
                    </p> */}
                  {/* <p className="listItem">
                    <img src={CheckIcon} alt="check icon" />
                    No KYC
                  </p> */}
                  {/* <p className="listItem">
                    <img src={CheckIcon} alt="check icon" />
                    Safe and secure
                  </p>
                  <p className="listItem">
                    <img src={CheckIcon} alt="check icon" />
                    Pay with credit card
                  </p>
                  <p className="listItem">
                    <img src={CheckIcon} alt="check icon" />
                    Cancel anytime
                  </p> */}
                {/* </div> */}

                <div className="svBtnBox">
                  <BubbleSvgButton
                    onClick={handleJoining}
                    text={`Sign up`}
                    type="button"
                    variant="black"
                    containerStyling={{
                      justifyContent: "center",
                    }}
                  />
                </div>
                {/* in-progress */}
                {/* <div className="orBox">
                  <p className="orText">Or sign up faster</p>
                  </div>
                  <div className="fasterLoginOuter">
                  <div className="fasterLoginBox">
                  <button
                      className="fasterLoginBtn"
                      onClick={telegramRedirectUrl}
                      type="button"
                    >
                      <img alt="" src={Telegram} />
                    </button>
                    
                    <button
                      className="fasterLoginBtn"
                      onClick={loginWithDiscord}
                      type="button"
                      >
                      <img alt="" src={Discord} />
                    </button>
                    
                    <button
                      className="fasterLoginBtn"
                      onClick={binanceButtonClick}
                      type="button"
                    >
                    <img alt="" src={Binance} />
                    </button>

                    <button
                      className="fasterLoginBtn"
                      onClick={byBitButtonClick}
                      type="button"
                      >
                      <img alt="" src={Bybit} />
                      </button>
                  </div>
                  </div> */}
                <div className="privacyContentBox">
                  <p>
                    By continuing, you agree to accept our <br />
                    <Link to="http://copyyy.it/privacy-policies">
                      <strong>Privacy Policy</strong>
                    </Link>{" "}
                    &{" "}
                    <Link to="http://copyyy.it/terms-and-conditions">
                      <strong>Terms of Service</strong>
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        
      )}
    </>
  );
};

const StarRating = ({ averageRating }) => {
  const roundedRating = Math.ceil(averageRating);

  const fullStars = Math.min(roundedRating, 5) || 0;
  const emptyStars = 5 - fullStars || 0;

  return (
    <div className="starBox">
      {/* Full stars */}
      {[...Array(fullStars)].map((_, index) => (
        <img key={index} src={StarImg} alt="Full Star" />
      ))}

      {/* Empty stars */}
      {[...Array(emptyStars)].map((_, index) => (
        <img key={index} src={FadeStarImg} alt="Empty Star" />
      ))}
    </div>
  );
};

export default OnboardingCM;
